module.exports = __webpack_public_path__ + "static/media/event1-home.dd6d72a4.jpg";